import { IContent, ILesson, enLessonType } from 'interface/lesson';
import Audio from './ContentTypes/audio';
import Embed from './ContentTypes/embed';
import Video from './ContentTypes/video';
import Videozz from './ContentTypes/Videozz';
import FabricaDeProvasPlayer from './ContentTypes/FabricaDeProvas';
import LessonTopics from 'components/Forum/LessonTopics';
import Skeleton from '@material-ui/lab/Skeleton';

import makeStyles from '@material-ui/core/styles/makeStyles';
import { Button, Typography } from '@material-ui/core';
import SettingsIcon from 'mdi-react/SettingsIcon';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'hooks/redux';
import { disableToastVideoQuality } from 'redux/lesson/slice';
import { useToastCustom } from 'hooks/useToastCustom';
import { useEffect } from 'react';

interface IPlayer {
  drmActive: number;
  embed?: any;
  type: {
    id?: number;
  };
  status: string;
  courseHash: string;
  content?: IContent;

  sessionCount?: number;
  lessonPageCount?: number;
  lesson?: ILesson;
  downloadAudioFile?: boolean;
  courseId: number;
}

const useStyles = makeStyles((theme) => ({
  marginContent: {
    padding: '12px 0',
  },
  toastContainer: {
    display: 'flex',
    gap: 10,
    alignItems: 'center',
  },
}));

const Player = (props: IPlayer) => {
  const classes = useStyles();
  const activeCourseId = useAppSelector((state) => state.newLesson.activeCourseId);

  useEffect(() => {
    const el = document.querySelector('#content');
    el.scrollIntoView();
  }, []);

  const dispatch = useDispatch();
  const { toast, handleClose } = useToastCustom();

  const { type, embed, content, drmActive, courseId } = props;
  const listShowVideoToast = [enLessonType.YOUTUBE_VIMEO, enLessonType.SAFE_VIDEO];

  const toastContent = (
    <div aria-label='Aviso informativo' className={classes.toastContainer}>
      <Typography variant='body1'>
        Caso o vídeo esteja apresentando problemas para carregar, experimente reduzir a qualidade clicando no ícone{' '}
        <span>
          <SettingsIcon size={16} />
        </span>{' '}
        do vídeo
      </Typography>
      <Button onClick={handleClose} size='small' variant='outlined' color='default'>
        Entendi
      </Button>
    </div>
  );

  if ((activeCourseId === null || activeCourseId !== courseId) && listShowVideoToast.includes(type.id)) {
    toast(toastContent, { autoClose: 5000, direction: 'bottomCenter' });
    dispatch(disableToastVideoQuality({ courseId }));
  }

  const choiceContentType = {
    [enLessonType.LOADING]: <Skeleton variant='rect' animation='wave' height={500} />,
    [enLessonType.YOUTUBE_VIMEO]: <Video content={content} drmActive={drmActive}></Video>,
    [enLessonType.EMBED]: <Embed content={embed} type={type.id} />,
    [enLessonType.TEXT]: <Embed content={embed} type={type.id} />,
    [enLessonType.AUDIO]: <Audio content={content} />,
    [enLessonType.VIDEOZZ]: <Videozz idVideo={content?.content} />,
    [enLessonType.FABRICA_PROVAS]: <FabricaDeProvasPlayer embed={embed} />,
    [enLessonType.TOPIC]: <LessonTopics content={content} />,
    [enLessonType.SAFE_VIDEO]: <Video content={content} drmActive={drmActive}></Video>,
  };

  return (
    <section aria-label='Conteúdo da aula' id='content' className={classes.marginContent}>
      {choiceContentType[type.id]}
    </section>
  );
};

export default Player;
